export default __webpack_public_path__ + "static/customer3-030e344011a041f4cd4637de4af93a0d.jpg";